import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { faFlag } from '@fortawesome/free-solid-svg-icons';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../../store';
import { setSelectedFaction } from '../../store/orbatSlice';
import { SidebarDropdown } from '../common/SidebarDropdown';

export default function FactionSwitcher() {
    const dispatch = useDispatch<AppDispatch>();
    const factions = useSelector((state: RootState) => state.orbat.factions);
    const selectedFactionId = useSelector((state: RootState) => state.orbat.selectedFactionId);

    const selectedFaction = factions.find((f) => f.id === selectedFactionId);

    const handleSelect = (factionId: string | null) => {
        dispatch(setSelectedFaction(factionId));
    };

    return (
        <SidebarDropdown
            icon={faFlag}
            label={selectedFaction?.name || 'No Faction'}
            toggleId="faction-dropdown"
        >
            {factions.map((faction) => (
                <Dropdown.Item
                    key={faction.id}
                    active={faction.id === selectedFactionId}
                    onClick={() => handleSelect(faction.id)}
                >
                    {faction.name}
                </Dropdown.Item>
            ))}
            {factions.length === 0 && (
                <Dropdown.Item disabled>No factions available</Dropdown.Item>
            )}
        </SidebarDropdown>
    );
}
